import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { Autocomplete, Avatar, Popper, TextField } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { VENDOR_IMAGE_URL } from '../../../../constants/Config';

const VendorSelectWithSearch = ({ setSelectedVendor, selectedVendor, setSelectedNewVendor }) => {
  // EditorVendorDetails's Data
  let vendorNameList = useSelector((state) => state?.vendorNameList?.user?.data?.value);

  let vendorNameListData = [];
  try {
    vendorNameListData = vendorNameList ? JSON.parse(vendorNameList) : [];
  } catch (error) {
    vendorNameListData = [];
  }

  return (
    <Autocomplete
      options={vendorNameListData}
      getOptionLabel={(option) => option?.Name || ''}
      value={selectedVendor ? vendorNameListData.find((vendor) => vendor.Id === selectedVendor) : null}
      onChange={(event, newValue) => {
        setSelectedVendor(newValue ? newValue.Id : null);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search Vendor Name"
          fullWidth
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                {selectedVendor && (
                  <Avatar
                    alt="image"
                    src={
                      selectedVendor?.ProfilePicture ? `${VENDOR_IMAGE_URL}/${selectedVendor?.ProfilePicture}` : null
                    }
                    sx={{ width: 30, height: 30, marginRight: 1 }}
                  />
                )}
                {params.InputProps.startAdornment}
              </>
            ),
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.Id} className="px-3 my-3">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              position: 'relative',
            }}
            onClick={() => setSelectedNewVendor(option)}
          >
            <Avatar
              alt="image"
              src={option?.ProfilePicture ? `${VENDOR_IMAGE_URL}/${option?.ProfilePicture}` : null}
              sx={{ width: 30, height: 30, marginRight: 2 }}
            />
            <span style={{ flex: 1 }}>
              {option?.Name}{' '}
              {option?.IsInHouse === 1 && <HomeOutlinedIcon style={{ color: '#190041', marginLeft: 8 }} />}
            </span>

            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: option?.isClaimed === 1 ? 'red' : 'green',
                border: '2px solid white',
                marginLeft: 10,
                position: 'absolute',
                bottom: '1px',
                left: '10px',
              }}
            />
          </div>
        </li>
      )}
      PopperComponent={(props) => <Popper {...props} sx={{ zIndex: 1300 }} />}
      style={{ width: '100%' }}
      disablePortal
    />
  );
};

export default VendorSelectWithSearch;
